import * as React from 'react';
import { useEffect } from 'react';

import { useStores } from 'hooks';
import { useEgClickstream } from '@shared-ui/clickstream-analytics-context';

import { SearchWidget, SearchWidgetProvider } from 'features/search-widget';
import { searchWidgetPresentedEvent } from 'modules/analytics';

function SearchWidgetPage(): JSX.Element {
  const {
    app: {
      program,
      analyticData: { referrerIdPrefix },
    },
  } = useStores();

  const track = useEgClickstream();

  useEffect(() => {
    searchWidgetPresentedEvent(track, program, referrerIdPrefix);
  }, [track, program, referrerIdPrefix]);

  return (
    <SearchWidgetProvider>
      <main className="search-widget-page">
        <SearchWidget />
      </main>
    </SearchWidgetProvider>
  );
}

export default SearchWidgetPage;
export { SearchWidgetPage };
